// AUTO-GENERATED from content/dataset.ndjson by content/_gen-downloads.mjs.
// Flat downloads model (Phase 2): one typed list + enum metadata, replacing the
// normalized productFile + productFileCategory + productFileType + file-asset join.
/* eslint-disable */

export const CATEGORIES = {
  "DFP15 Wheel Base": {
    "label": "DFP15 Wheel Base",
    "order": 3,
    "hide": false,
    "image": "/assets/images/9f4eeb27d0f0b9e019650a766620ace424cabf27-2000x2000.png"
  },
  "R295 Steering Wheel": {
    "label": "R295 Steering Wheel",
    "order": 2,
    "hide": false,
    "image": "/assets/images/092e3a4a37b7e2edae59d9acce9baf0ec5eabb17-1601x900.png"
  },
  "FORMULA_STEERING_WHEEL": {
    "label": "Formula steering wheel",
    "order": 4,
    "hide": false,
    "image": "/assets/images/0a8e9ff352ddddcaaeb062ffca9fb7ce067ab54f-450x450.png"
  },
  "DAMPERS": {
    "label": "Dampers",
    "order": 5,
    "hide": false,
    "image": "/assets/images/b82eda3d41b75b96e03e86301a668edaf4192c87-2000x2000.png"
  },
  "WHEEL_BASE": {
    "label": "(u)DFP20 Wheel Base",
    "order": 4,
    "hide": false,
    "image": "/assets/images/6030e886893f50a8621bf5c7b504a074c2831f42-450x450.png"
  },
  "QR Connect Wheel Adapter": {
    "label": "QR Connect Wheel Adapter",
    "order": 6,
    "hide": false,
    "image": "/assets/images/dfac0af1589891c00219d3b782a7520a71dfd197-1383x1383.png"
  },
  "MARKETING_ASSETS": {
    "label": "Marketing and branding assets",
    "order": 5,
    "hide": true,
    "image": "/assets/images/76061009b7e163bfb878aa911419deb373b2cf2e-160x160.svg"
  },
  "PEDALS_THROTTLE_AND_BRAKE": {
    "label": "Throttle & brake",
    "order": 5,
    "hide": false,
    "image": "/assets/images/a947e9e0b5f8e3ff23a4791a3f5ac92ec8376555-450x450.png"
  },
  "CONFIG_TOOL": {
    "label": "VRS® ONE",
    "order": 1,
    "hide": false,
    "image": "/assets/images/a915692d98ef7bd6d0e6719475d9e37413732aa8-400x400.svg"
  },
  "QR Connect (u)DFP20 Adapter": {
    "label": "QR Connect (u)DFP20 Adapter",
    "order": 7,
    "hide": false,
    "image": "/assets/images/6ea4b8a3738f2d9442e7935d8b9f42964b75faf2-2000x2000.png"
  },
  "GT-2 Cockpit": {
    "label": "GT-2 Cockpit",
    "order": 8,
    "hide": false,
    "image": "/assets/images/4d0134114f50ea57c98cda2517c3080661c8379a-1280x638.png"
  }
}

export const TYPES = {
  "USER_MANUAL": {
    "label": "User manual",
    "order": 2
  },
  "VRS_LOGOS": {
    "label": "VRS® logos",
    "order": 5
  },
  "CONFIG_TOOL_INSTALLER": {
    "label": "Config Tool NextGenFFB Installer",
    "order": 1
  },
  "VRS_ONE_INSTALLER": {
    "label": "VRS ONE Installer",
    "order": 1
  },
  "SIMHUB_STANDALONE_PROFILE": {
    "label": "SimHub Standalone Profile",
    "order": 6
  },
  "CONFIG_TOOL_DEBUG": {
    "label": "Legacy Config Tool (Debug)",
    "order": 3
  },
  "CONFIG_TOOL_STANDALONE": {
    "label": "Config tool NextGenFFB Standalone",
    "order": 1
  },
  "ATSR_INSTALLATION_GUIDE": {
    "label": "ATSR Hub Profile - Installation Guide",
    "order": 8
  },
  "FIRMWARE": {
    "label": "Firmware",
    "order": 1
  },
  "ATSR_HUB_PROFILE": {
    "label": "ATSR Hub Profile",
    "order": 7
  },
  "WHEEL_BUTTON_MAPPING": {
    "label": "Wheel button mapping",
    "order": 2
  },
  "VRS_BRAND_GUIDE": {
    "label": "VRS® brand guide",
    "order": 3
  },
  "ASSEMBLY_INSTRUCTIONS": {
    "label": "Assembly instructions",
    "order": 1
  }
}

export const downloads = [
  {
    "category": "GT-2 Cockpit",
    "type": "ASSEMBLY_INSTRUCTIONS",
    "label": "VRS-GT-2-manual-v1.1.pdf",
    "date": "2026-08-05",
    "url": "/assets/files/VRS-GT-2-manual-v1.1.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "VRS_ONE_INSTALLER",
    "label": "VRS ONE Installer",
    "date": "2026-06-02",
    "url": "/assets/files/VrsOneSetup-1.0.14.exe",
    "hideDownloadButton": false,
    "warningText": null,
    "howToUrl": "https://youtu.be/2cfRwk1rVKw"
  },
  {
    "category": "QR Connect Wheel Adapter",
    "type": "USER_MANUAL",
    "label": "QR Connect Wheel adapter User manual v1.3 20260527.pdf",
    "date": "2026-05-27",
    "url": "/assets/files/QR-Connect-Wheel-adapter-User-manual-v1.3-20260527.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "R295 Steering Wheel",
    "type": "USER_MANUAL",
    "label": "VRS R295 Steering Wheel User Manual v2.1.pdf",
    "date": "2026-02-10",
    "url": "/assets/files/VRS-R295-Steering-Wheel-User-Manual-v2.1.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "R295 Steering Wheel",
    "type": "ATSR_INSTALLATION_GUIDE",
    "label": "ATSR-Hub-EVO_R295-Setup.pdf",
    "date": "2026-02-10",
    "url": "/assets/files/ATSR-Hub-EVO_R295-Setup.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "FORMULA_STEERING_WHEEL",
    "type": "USER_MANUAL",
    "label": "user-manual-formula-wheel-v2.2.pdf",
    "date": "2026-02-10",
    "url": "/assets/files/user-manual-formula-wheel-v2.2.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "R295 Steering Wheel",
    "type": "ATSR_HUB_PROFILE",
    "label": "ATSR_Hub_EVO.dll",
    "date": "2026-02-10",
    "url": "/assets/files/ATSR_Hub_EVO.dll",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.1.0.0.1.app.exe",
    "date": "2026-01-16",
    "url": "/assets/files/DirectForce.1.0.0.1.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_INSTALLER",
    "label": "DirectForce.1.0.0.1.app-installer.msi",
    "date": "2026-01-16",
    "url": "/assets/files/DirectForce.1.0.0.1.app-installer.msi",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_INSTALLER",
    "label": "DirectForce.1.0.0.0.app-installer",
    "date": "2026-01-06",
    "url": "/assets/files/DirectForce.1.0.0.0.app-installer.msi",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.1.0.0.0.app.exe",
    "date": "2025-12-18",
    "url": "/assets/files/DirectForce.1.0.0.0.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "DFP15 Wheel Base",
    "type": "USER_MANUAL",
    "label": "VRS DFP15 User manual v1.4 20251215.pdf",
    "date": "2025-12-15",
    "url": "/assets/files/VRS-DFP15-User-manual-v1.4-20251215.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.0.9.9.7.app.exe",
    "date": "2025-11-07",
    "url": "/assets/files/DirectForce.0.9.9.7.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "WHEEL_BASE",
    "type": "USER_MANUAL",
    "label": "VRS uDFP20 Wheel Base User Manual v1.3.pdf",
    "date": "2025-10-14",
    "url": "/assets/files/VRS-uDFP20-Wheel-Base-User-Manual-v1.3.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "R295 Steering Wheel",
    "type": "USER_MANUAL",
    "label": "VRS R295 Steering Wheel User Manual v2.0.pdf",
    "date": "2025-10-14",
    "url": "/assets/files/VRS-R295-Steering-Wheel-User-Manual-v2.0.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "DFP15 Wheel Base",
    "type": "USER_MANUAL",
    "label": "VRS DFP15 User manual v1.2 202505910.pdf",
    "date": "2025-09-10",
    "url": "/assets/files/VRS-DFP15-User-manual-v1.2-202505910.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.0.9.8.9.app.exe",
    "date": "2025-08-21",
    "url": "/assets/files/DirectForce.0.9.8.9.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "FORMULA_STEERING_WHEEL",
    "type": "USER_MANUAL",
    "label": "Formula Steering Wheel User Manual v2.pdf",
    "date": "2025-08-20",
    "url": "/assets/files/Formula-Steering-Wheel-User-Manual-v2.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "QR Connect (u)DFP20 Adapter",
    "type": "USER_MANUAL",
    "label": "QR Connect DFP20 Adapter Assembly Manual 4.2.pdf",
    "date": "2025-08-20",
    "url": "/assets/files/QR-Connect-DFP20-Adapter-Assembly-Manual-4.2.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "R295 Steering Wheel",
    "type": "USER_MANUAL",
    "label": "VRS R295 Steering Wheel User Manual v1.9.pdf",
    "date": "2025-08-20",
    "url": "/assets/files/VRS-R295-Steering-Wheel-User-Manual-v1.9.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.0.9.8.8.app.exe",
    "date": "2025-07-21",
    "url": "/assets/files/DirectForce.0.9.8.8.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.0.9.8.7.app.exe",
    "date": "2025-06-11",
    "url": "/assets/files/DirectForce.0.9.8.7.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "R295 Steering Wheel",
    "type": "USER_MANUAL",
    "label": "VRS R295 Steering Wheel User Manual v1.8.pdf",
    "date": "2025-06-03",
    "url": "/assets/files/VRS-R295-Steering-Wheel-User-Manual-v1.8.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.0.9.8.6.app.exe",
    "date": "2025-05-26",
    "url": "/assets/files/DirectForce.0.9.8.6.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.0.9.8.5.app.exe",
    "date": "2025-05-14",
    "url": "/assets/files/DirectForce.0.9.8.5.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "QR Connect Wheel Adapter",
    "type": "USER_MANUAL",
    "label": "QR Connect Wheel adapter User manual v1.2 20250514.pdf",
    "date": "2025-05-14",
    "url": "/assets/files/QR-Connect-Wheel-adapter-User-manual-v1.2-20250514.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "R295 Steering Wheel",
    "type": "USER_MANUAL",
    "label": "VRS R295 Steering Wheel User Manual v1.7 20250514.pdf",
    "date": "2025-05-08",
    "url": "/assets/files/VRS-R295-Steering-Wheel-User-Manual-v1.7-20250514.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "DFP15 Wheel Base",
    "type": "USER_MANUAL",
    "label": "DFP15 User Manual v1.1 20250508.pdf",
    "date": "2025-05-08",
    "url": "/assets/files/DFP15-User-Manual-v1.1-20250508.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "R295 Steering Wheel",
    "type": "SIMHUB_STANDALONE_PROFILE",
    "label": "SimHub Standalone Profile 1.0",
    "date": "2025-05-05",
    "url": "/assets/files/VRS-R295-Standalone-SimHub-Profile.ledsprofile",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "R295 Steering Wheel",
    "type": "ATSR_HUB_PROFILE",
    "label": "ATSR Hub Profile 1.0",
    "date": "2025-05-05",
    "url": "/assets/files/VRS-R295-ATSR-Hub-Profile.ledsprofile",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "R295 Steering Wheel",
    "type": "ATSR_INSTALLATION_GUIDE",
    "label": "ATSR Hub Profile - Installation Guide",
    "date": "2025-05-05",
    "url": "/assets/files/Manual_ATSR-Wheel-Profiles.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.0.9.8.4.app.exe",
    "date": "2025-04-30",
    "url": "/assets/files/DirectForce.0.9.8.4.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "R295 Steering Wheel",
    "type": "USER_MANUAL",
    "label": " VRS R295 Steering Wheel User Manual v1.3 20250418.pdf",
    "date": "2025-04-18",
    "url": "/assets/files/VRS-R295-Steering-Wheel-User-Manual-v1.3-20250418.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.0.9.8.3.app.exe",
    "date": "2025-04-07",
    "url": "/assets/files/DirectForce.0.9.8.3.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.0.9.8.1.app.exe",
    "date": "2025-04-01",
    "url": "/assets/files/DirectForce.0.9.8.1.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.0.9.7.6.app.exe",
    "date": "2025-03-12",
    "url": "/assets/files/DirectForce.0.9.7.6.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "QR Connect (u)DFP20 Adapter",
    "type": "USER_MANUAL",
    "label": "QR Connect DFP20 Adapter Assembly Manual 2.0.pdf",
    "date": "2025-02-13",
    "url": "/assets/files/QR-Connect-DFP20-Adapter-Assembly-Manual-2.0.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "QR Connect Wheel Adapter",
    "type": "USER_MANUAL",
    "label": "QR Connect Wheel Adapter Manual.pdf",
    "date": "2025-02-03",
    "url": "/assets/files/QR-Connect-Wheel-adapter-User-manual.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "DAMPERS",
    "type": "USER_MANUAL",
    "label": "Dampers User Manual.pdf",
    "date": "2025-01-13",
    "url": "/assets/files/user-manual-dampers.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.0.9.6.16.app.exe",
    "date": "2025-01-07",
    "url": "/assets/files/DirectForce.0.9.6.16.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.0.9.6.0.app.exe",
    "date": "2024-12-11",
    "url": "/assets/files/DirectForce.0.9.6.0.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "DirectForce.0.9.4.6.app.exe",
    "date": "2024-09-25",
    "url": "/assets/files/DirectForce.0.9.4.6.app.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_STANDALONE",
    "label": "VRS_DirectForcePro_Config_2023-12-26-fwfix.exe",
    "date": "2023-12-26",
    "url": "/assets/files/VRS_DirectForcePro_Config_2023-12-26-fwfix.exe",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "USER_MANUAL",
    "label": "Troubleshooting guide",
    "date": "2023-12-24",
    "url": "/assets/files/VRS-DirectForce-Config-Tool-Troubleshooting.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "FORMULA_STEERING_WHEEL",
    "type": "USER_MANUAL",
    "label": "Formula Steering Wheel User Manual.pdf",
    "date": "2023-12-06",
    "url": "/assets/files/Formula-Steering-Wheel-User-Manual.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "MARKETING_ASSETS",
    "type": "VRS_BRAND_GUIDE",
    "label": "vrs-brand-guidelines.pdf",
    "date": "2023-08-17",
    "url": "/assets/files/vrs-brand-guidelines.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "CONFIG_TOOL",
    "type": "CONFIG_TOOL_DEBUG",
    "label": "VRS_DFP_Config.zip",
    "date": "2023-06-21",
    "url": "/assets/files/VRS_DFP_Config.zip",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "WHEEL_BASE",
    "type": "FIRMWARE",
    "label": "VRS-DirectForcePro-WheelBase-v111-rc4.fw",
    "date": "2023-03-02",
    "url": "/assets/files/VRS-DirectForcePro-WheelBase-v111-rc4.fw",
    "hideDownloadButton": false,
    "warningText": "Don't use this firmware unless you're using the Legacy tool. The new VRS® DirectForce® Config Tool has self-contained firmware. "
  },
  {
    "category": "FORMULA_STEERING_WHEEL",
    "type": "WHEEL_BUTTON_MAPPING",
    "label": "Wheel_Button_Mappings.pdf",
    "date": "2023-02-05",
    "url": "/assets/files/Wheel_Button_Mappings.pdf",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "PEDALS_THROTTLE_AND_BRAKE",
    "type": "FIRMWARE",
    "label": "VRS-DirectForcePro-Pedals-v111-rc3-2.fw",
    "date": "2022-04-29",
    "url": "/assets/files/VRS-DirectForcePro-Pedals-v111-rc3-2.fw",
    "hideDownloadButton": false,
    "warningText": "Don't use this firmware unless you're using the Legacy tool. The new VRS® DirectForce® Config Tool has self-contained firmware. "
  },
  {
    "category": "WHEEL_BASE",
    "type": "FIRMWARE",
    "label": "VRS-DirectForcePro-WheelBase-v111-rc3.fw",
    "date": "2022-04-25",
    "url": "/assets/files/VRS-DirectForcePro-WheelBase-v111-rc3.fw",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "PEDALS_THROTTLE_AND_BRAKE",
    "type": "FIRMWARE",
    "label": "VRS-DirectForcePro-Pedals-v111-rc3.fw",
    "date": "2022-04-25",
    "url": "/assets/files/VRS-DirectForcePro-Pedals-v111-rc3.fw",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "WHEEL_BASE",
    "type": "FIRMWARE",
    "label": "VRS-DirectForcePro-WheelBase-v111-rc2.fw",
    "date": "2021-09-11",
    "url": "/assets/files/VRS-DirectForcePro-WheelBase-v111-rc2.fw",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "PEDALS_THROTTLE_AND_BRAKE",
    "type": "FIRMWARE",
    "label": "VRS-DirectForcePro-Pedals-v111-rc2.fw",
    "date": "2021-09-06",
    "url": "/assets/files/VRS-DirectForcePro-Pedals-v111-rc2.fw",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "WHEEL_BASE",
    "type": "FIRMWARE",
    "label": "VRS-DirectForcePro-WheelBase-v111-rc1.fw",
    "date": "2021-09-06",
    "url": "/assets/files/VRS-DirectForcePro-WheelBase-v111-rc1.fw",
    "hideDownloadButton": false,
    "warningText": null
  },
  {
    "category": "PEDALS_THROTTLE_AND_BRAKE",
    "type": "FIRMWARE",
    "label": "VRS-DirectForcePro-Pedals-r111-rc1.fw",
    "date": "2021-06-11",
    "url": "/assets/files/VRS-DirectForcePro-Pedals-r111-rc1.fw",
    "hideDownloadButton": false,
    "warningText": null
  }
]

// Grouped + sorted for rendering: [{ category, label, image, items: [...] }]
// ordered by category.order, hidden categories removed, items newest-first.
export function downloadsByCategory() {
  const groups = new Map()
  for (const d of downloads) {
    if (!groups.has(d.category)) groups.set(d.category, [])
    groups.get(d.category).push(d)
  }
  return [...groups.keys()]
    .filter((c) => CATEGORIES[c] && !CATEGORIES[c].hide)
    .sort((a, b) => CATEGORIES[a].order - CATEGORIES[b].order)
    .map((c) => ({ category: c, label: CATEGORIES[c].label, image: CATEGORIES[c].image, items: groups.get(c) }))
}
